import React from "react";
// Sections
import Header from "../components/Sections/Header";
import Services from "../components/Sections/Services";
import HomeCarpets from "../components/Sections/HomeCarpets";
import Blog from "../components/Sections/Blog";
import Contact from "../components/Sections/Contact";

export default function Home() {
    return (
        <>
            <Header />
            {/*<HomeCarpets />*/}
            <Services />
            <Blog />
            <Contact />
        </>
    );
}


